/** @jsx h */
const Checkbox = ({ option, filterName, handleChange, pluginNamespace }) => (
  <div class="checkbox-group">
    <label class="checkbox">
      <input
        id={option.value}
        type="checkbox"
        name={`${pluginNamespace}[filter][]`}
        value={`${filterName}:${option.value}`}
        data-label={option.label}
        onChange={handleChange}
        checked={option.selected}
      />
      <span class="box" />
      <span class="checkbox__label">{option.label}</span>
    </label>
  </div>
);

export default Checkbox;
